export const formatPhone = (phone: string): string => {
  if (phone) {
    /* eslint-disable no-useless-escape */
    phone = phone.replace(/[().\-\/ ]/g, '')
    phone = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`
  }

  return phone
}

export const normalizeSpaces = (str: string): string => str.replace(/ {2,}/g, ' ')
